export const GAME_TITLE = "Wedding Connections";
export const MAX_MISTAKES = 4;
